<eo-base-form-control
  [styleClass]="getStyleClass()"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [notApplicableLabel]="notApplicableLabel"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <textarea
    pInputTextarea
    attr.aria-describedby="{{ id }}-help"
    class="w-full {{ getInputStyleClass() }}"
    [id]="id"
    [tabindex]="getTabIndex()"
    [placeholder]="getPlaceholder()"
    [formControl]="getFormControl()"
    [rows]="getRows()"
    [cols]="getCols()"
    [maxlength]="getMaxlength()"
    [minlength]="getMinlength()"
    [readonly]="getReadonly()"
    [disabled]="getDisabled()"
    [pKeyFilter]="getPKeyFilter()"
    (change)="change.emit($event)"
    (focus)="focus.emit($event)"
    (blur)="blur.emit($event)"
    (onRemove)="onRemoveHandler()"
    (onChange)="onChangeHandler($event)"
    (onBlur)="onBlurHandler($event)"
    (onFocus)="onFocusHandler($event)"
  ></textarea>
  <button *ngIf="getShowClear()" type="button" (click)="clear()">
    Καθαρισμός
  </button>
</eo-base-form-control>
